import keyBy from 'lodash/keyBy';
import { sum } from 'd3-array';
import booleanDisjoint from '@turf/boolean-disjoint';
import union from '@turf/union';

export const geoFilter = (fcOne, fcTwo) => {
  if (fcTwo.features.length === 0) return [];
  const u = fcTwo.features.reduce((acc, cur) => union(acc, cur.geometry), fcTwo.features[0].geometry)
  return fcOne.features.filter(f => !booleanDisjoint(f.geometry, u)).map(f => f.properties.id);
}

// export const getTotals = (sa2s) => {
//   const totals = {}
//   Object.keys(sa2s.features[0].properties).forEach(key => {
//     totals[key] = sum(sa2s.features.filter(f => !isNaN(f.properties[key])), f => f.properties[key])
//   })
//   const areaData = [1991, 2001, 2006, 2011, 2016].map(year => ({x: new Date(year, 1, 1), y: totals[`Pop in ${year}`]}))
//   areaData.push({x: new Date(2036, 1, 1), y: totals['2036 population current trend']})
//   return areaData;
// }


export const geojsonLayers = (buildings, sa2s) => {

  const buildingLayer =  {
    id: '3d-building-layer',
    type: 'fill-extrusion',
    source: {
      type: "geojson",
      data: buildings,
    },
    paint: {
      'fill-extrusion-height': ["get", "calcHeight"],
      'fill-extrusion-base': 0,
      'fill-extrusion-color': "#ffad69",
      'fill-extrusion-opacity': 0.7,
    }
  }

  // const sa2Layer = {
  //   id: 'sa2-layer',
  //   type: 'fill',
  //   source: {
  //     type: "geojson",
  //     data: sa2s,
  //   },
  //   paint: {
  //     'fill-color': "darkred",
  //     'fill-opacity': [
  //       'case',
  //         ['boolean', ['feature-state', 'hover'], false],
  //         0.5,
  //         0.0
  //       ]
  //   }
  // }


 const sa2LayerLine = {
    id: 'sa2-layer-line',
    type: 'line',
    source: {
      type: "geojson",
      data: sa2s,
    },
    paint: {
      'line-color': "darkred",
    }
  }


  const existing = {
    // "minzoom": 13,
    // "minzoom": 0,
    // "maxzoom": 24,
    // "maskLevel": 15,
    // "filter": ["all", ["==", ["get", "underground"], "false"], ["!=", ["get", "extrude"], "false"] ],
    "id": "building-extrusion",
    "layout": {},
    "metadata": {
      "mapbox:featureComponent": "buildings",
      "mapbox:group": "Buildings, extruded"
    },
    "paint": {
      // "fill-extrusion-base": ["get", "min_height"],
      // "fill-extrusion-color": "hsl(35, 1%, 100%)",
      "fill-extrusion-color": "rgb(253, 235, 200)",
      "fill-extrusion-height": ["get", "height"]
    },
    "source": {
      // "minzoom": 0,
      // "maxzoom": 24,
      // "maskLevel": 15,
      //
      // "type": "vector",
      // "url": "mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2"
      "type": "geojson",
      "data": "https://storage.googleapis.com/city-app/brisbane/existing.json"
    },
    // "source-layer": "building",
    "type": "fill-extrusion"
  }

  return [
    existing,
    // sa2Layer,
    // sa2LayerLine,
    buildingLayer
  ]
}



// (acc, cur)
// export const initPopDensity = (buildings, sa2s) => {
//     return sa2s.features.reduce((acc, cur) => {
//         const km2 = cur.properties.AREASQKM16
//         const pop = cur.properties['2036 population current trend']
//         return {...acc, [cur.properties.SA2_MAIN16]: pop / km2}
//     }, {})
// }


export const initScenario = (buildings, sa2s) => {
    return 1.   
}


export const getCurve = (buildings, sa2s) => {
    // const popDensity = initPopDensity(buildings, sa2s);
    const curveData = sa2s.features.map((f, fi) => {
      const km2 = f.properties.AREASQKM16
      const pop = f.properties['2036 Target Population']
      return {
        ...f.properties,
        initDensity: pop / km2,
      }
    })
    curveData.sort((a, b) => {
      return b.initDensity - a.initDensity
    })
    curveData.forEach((f, fi) => {
      f.x = fi
      f.y = f.initDensity
    })
    return curveData
} 


// taking "Pop in 2016" and 2020 mbox buildings we get 41824272/324631 = 129
const SQM_PER_PERSON = 100;


/*
   it is required that the total pop be the same
   so sum(density * area) should be constant
 */

export const updateCalcHeight = (buildings, sa2s, splinePoints) => {

  // mean density shouldn't change
  const initPopTotal = sum(splinePoints, f => f.initDensity);
  const newPopTotal = sum(splinePoints, f => f.yHat);
  const yHat = splinePoints.reduce((acc, cur) => {
    return {...acc, [cur.SA2_MAIN16]: cur.yHat / newPopTotal * initPopTotal}
  })

  sa2s.features.forEach((sa2) => {
    const SA2_MAIN16 = sa2.properties.SA2_MAIN16
    const km2 = sa2.properties.AREASQKM16
    // const pop = sa2.properties['2036 population current trend']
    // TODO density should come from splinePoints and func -> shoud be weighted so as to equal out?
    // const density = pop / km2;
    const density = yHat[SA2_MAIN16];

    const newPop = density * km2;
    // TODO lets get the most recent estimates
    const currentPop = sa2.properties['Pop in 2016'];
    const extraPop = newPop - currentPop;
    
    const areaBuildings = buildings.features.filter(f => f.properties.SA2_MAIN16 === SA2_MAIN16)
    const totalFloorPlate = sum(areaBuildings, f => f.properties.area)

    // TODO do rounding per building not per sa2
    // TODO what about the knocked down stuff? att 10%?
    const extraFloors = Math.ceil((extraPop * SQM_PER_PERSON) / totalFloorPlate);
    const extraHeight = 3 * extraFloors;
    areaBuildings.forEach(f => {
      f.properties.calcHeight = extraHeight;
    })

    // console.log('extra added', SA2_MAIN16, extraPop, sum(areaBuildings, f => (f.properties.calcHeight) / 3 * f.properties.area / SQM_PER_PERSON ))

  })
}

